import { render, staticRenderFns } from "./buffetTableHeader.vue?vue&type=template&id=cd6cafd6&scoped=true&"
import script from "./buffetTableHeader.vue?vue&type=script&lang=js&"
export * from "./buffetTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./buffetTableHeader.vue?vue&type=style&index=0&id=cd6cafd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6cafd6",
  null
  
)

export default component.exports